<template>
  <v-layout>
    <color-picker :value="colors" @input="updateValue" />
  </v-layout>
</template>

<script>
import { Chrome } from 'vue-color';

// @vuese
// Color Picker
// @group Components/Forms
export default {
  components: { 'color-picker': Chrome },
  props: {
    // Schema przekazana do komponentu
    model: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      colors: { hex: '#ffffff' }
    };
  },
  methods: {
    // @vuese
    // Zapisuje wybrany kolor w Schema
    updateValue(newValue) {
      this.colors = newValue;
      this.model.$model = newValue.hex;
    }
  },
  beforeMount() {
    this.colors = this.model.$model;
  }
};
</script>
